import { useState } from 'react';
import cn from 'classnames';
import AddressCard from '../addressCard';
import AddressForm from '../addressForm';
import DeleteAddress from '../deleteAddress';
import styles from './customerAddressPanel.module.scss';

const CustomerAddressPanel = ({
  customer,
  toggleAddForm,
  setAddToggleForm,
  toggleUpdateForm,
  setUpdateToggleForm,
  accountpagenavigation,
  addressbookaccountpage,
  addaddressformaccountpage,
  secondaddressbookaccountpage,
}) => {
  const { navigationAddressBook } = accountpagenavigation;
  const { addressPageTitle, addAnAddressButtonContent } = addressbookaccountpage;
  const { mainAddressPointer, editAddressTitle } = secondaddressbookaccountpage;

  const [toggleDeleteAddress, setToggleDeleteAddress] = useState(false);
  const [updateAddress, setUpdateAddress] = useState({});
  const { defaultAddress, addresses } = customer;
  return (
    <>
      {!toggleDeleteAddress && !toggleUpdateForm && !toggleAddForm && (
        <>
          <h1 className={styles.title}>{navigationAddressBook?.text}</h1>
          <h2 className={cn(styles.secondaryTitle, styles.addMargin)}>
            {!toggleAddForm ? `${addressPageTitle?.text}` : `${addAnAddressButtonContent?.text}`}
          </h2>
          <div className={styles.addressPanel}>
            <div className={styles.addresses}>
              <div className={styles.addressesContainer}>
                <div className={styles.panel}>
                  {!toggleAddForm && defaultAddress && (
                    <AddressCard
                      key={defaultAddress.id}
                      address={defaultAddress}
                      isDefaultAddress
                      addressbookaccountpage={addressbookaccountpage}
                      customer={customer}
                      mainAddressPointer={mainAddressPointer}
                      setAddToggleForm={setAddToggleForm}
                      setUpdateAddress={setUpdateAddress}
                      setUpdateToggleForm={setUpdateToggleForm}
                      setToggleDeleteAddress={setToggleDeleteAddress}
                    />
                  )}
                  {!toggleAddForm &&
                    !toggleUpdateForm &&
                    addresses &&
                    addresses.edges.length >= 1 &&
                    addresses.edges.map(({ node }) => {
                      if (defaultAddress && node.id !== defaultAddress.id) {
                        return (
                          <AddressCard
                            addressbookaccountpage={addressbookaccountpage}
                            key={node.id}
                            address={node}
                            customer={customer}
                            mainAddressPointer={mainAddressPointer}
                            setUpdateAddress={setUpdateAddress}
                            setUpdateToggleForm={setUpdateToggleForm}
                            setToggleDeleteAddress={setToggleDeleteAddress}
                          />
                        );
                      }
                      return null;
                    })}
                </div>
              </div>

              {!toggleAddForm && !toggleUpdateForm && (
                <button
                  className={styles.addAddressButton}
                  type="submit"
                  onClick={() => setAddToggleForm(!toggleAddForm)}
                >
                  {addAnAddressButtonContent?.text}
                </button>
              )}
            </div>
          </div>
        </>
      )}
      {toggleAddForm && (
        <div className={styles.formContainer}>
          <h2 className={cn(styles.title)}>{addAnAddressButtonContent?.text}</h2>
          <AddressForm
            formType="Create"
            customer={customer}
            setAddToggleForm={setAddToggleForm}
            setUpdateToggleForm={setUpdateToggleForm}
            addaddressformaccountpage={addaddressformaccountpage}
            secondaddressbookaccountpage={secondaddressbookaccountpage}
          />
        </div>
      )}
      {toggleUpdateForm && (
        <div className={styles.formContainer}>
          <h2 className={cn(styles.secondaryTitle, styles.formMargin)}>{editAddressTitle?.text}</h2>
          <AddressForm
            formType="Update"
            customer={customer}
            toggleUpdateForm={toggleUpdateForm}
            setAddToggleForm={setAddToggleForm}
            setUpdateToggleForm={setUpdateToggleForm}
            currentAddress={updateAddress}
            addaddressformaccountpage={addaddressformaccountpage}
            secondaddressbookaccountpage={secondaddressbookaccountpage}
          />
        </div>
      )}
      {toggleDeleteAddress && (
        <DeleteAddress
          address={updateAddress}
          customer={customer}
          setToggleDeleteAddress={setToggleDeleteAddress}
          addressbookaccountpage={addressbookaccountpage}
        />
      )}
    </>
  );
};

export default CustomerAddressPanel;
